import Button from 'components/Form/Button';
import Input from 'components/Form/Input';
import UploadFile from 'components/Form/UploadFile';
import ContainerAuthenticated from 'containers/Authenticated';
import { CoreContext } from 'context/CoreContext';
import moment from 'moment';
import 'moment/locale/pt-br';
import { useCallback, useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Col, Row } from 'reactstrap';
import { DoLogout } from 'services/authentication';
import { ReadMe, UpdateMe } from 'services/me';
import { Load } from 'ui/styled';
import { parseStrapiImage } from 'utils';
import {
  DarboardUserImage,
  DarboardUserImageAction,
  DarboardUserImageActionIcon,
  DashboardButton,
  DashboardInput,
  DashboardText,
} from './styled';

export default function DashboardMe() {
  const history = useHistory();
  const navigate = (to) => history.push(`/${to}`);
  const { user, setUser } = useContext(CoreContext);
  const [preview, setPreview] = useState(
    user?.image?.url ? parseStrapiImage(user?.image?.url) : null
  );
  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(false);
  const exit = async () => {
    await DoLogout();
    navigate('login');
  };
  const takePic = async (result) => {
    setFetching(true);
    //console.log(result)
    if (result?.id) {
      await UpdateMe({ image: result.id });
      setPreview(parseStrapiImage(result?.url));
    }
    setFetching(false);
  };
  const init = useCallback(async () => {
    setLoading(true);
    const result = await ReadMe();
    if (result?.id) {
      setUser(result);
      if (result?.image?.url) {
        setPreview(parseStrapiImage(result?.image?.url));
      }
    }
    setLoading(false);
  }, [setUser]);

  useEffect(() => init(), [init]);

  return (
    <>
      <ContainerAuthenticated>
        <Row>
          <Col></Col>
          <Col sm={12} md={4}>
            <DarboardUserImage
              image={preview ? preview : '/images/no-user.png'}
            >
              <UploadFile
                onChange={takePic}
                onPreview={setPreview}
                proposalType={'Elegiveis'}
              >
                {fetching ? <Load /> : null}
                <DarboardUserImageAction>
                  <DarboardUserImageActionIcon />
                </DarboardUserImageAction>
                {fetching ? <Load /> : null}
                <DarboardUserImageAction>
                  <DarboardUserImageActionIcon />
                </DarboardUserImageAction>
              </UploadFile>
            </DarboardUserImage>
            <DashboardInput>
              <Input
                placeholder="Nome"
                value={user.username}
                onChange={() => null}
              />
            </DashboardInput>
            <DashboardInput>
              <Input
                placeholder="Email"
                value={user.email}
                onChange={() => null}
              />
            </DashboardInput>
            <DashboardText centred>
              Usuário desde {moment(user.createdAt).format('L')}
            </DashboardText>
            <DashboardButton>
              {/* <Button loading={loading} onClick={removeAccount} color="secondary">Excluir Conta</Button> */}
              <Button loading={loading} onClick={exit} color="secondary">
                Sair
              </Button>
            </DashboardButton>
          </Col>
          <Col></Col>
        </Row>
      </ContainerAuthenticated>
    </>
  );
}
